module.exports = __webpack_public_path__ + "media/images/btn_confirm-184cdb5988c3c2719d47de1a9464558b.gif";